import React from 'react';
import Image from 'next/image';
import { Saira, IBM_Plex_Sans } from 'next/font/google';

const saira = Saira({
  subsets: ['latin'],
  weight: ['700'],
  display: 'swap',
});

const ibmPlexSans = IBM_Plex_Sans({
  subsets: ['latin'],
  weight: ['600'],
  display: 'swap',
});

export interface CarAIBannerMobileProps {
  onBookDemo?: () => void;
}

export const CarAIBannerMobile: React.FC<CarAIBannerMobileProps> = ({
  onBookDemo,
}) => {
  const handleBookDemo = () => {
    if (onBookDemo) {
      onBookDemo();
    } else {
      // Default behavior - open CarAI demo booking
      window.open('https://carai.com', '_blank');
    }
  };

  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-r from-[#2D1B69] to-[#4A2B8F] pb-[24px] pt-[40px]">
      <div className="mx-auto w-full px-[16px]">
        <div className="flex flex-col items-center gap-[24px]">
          {/* Logo - Centered */}
          <div className="flex justify-center">
            <Image
              src="/images/caraibanner/logo.svg"
              alt="CarAI Logo"
              width={180}
              height={60}
              className="h-auto w-40"
              priority
            />
          </div>

          {/* Title - Centered */}
          <div className="flex justify-center text-center">
            <h2
              className={saira.className}
              style={{
                color: '#FFF',
                fontSize: '32px',
                fontWeight: 700,
                lineHeight: '40px',
              }}
            >
              AI Employee for Car Dealerships
            </h2>
          </div>

          {/* Button - Centered */}
          <div className="flex justify-center">
            <button
              onClick={handleBookDemo}
              aria-label="Book a Demo"
              className="cursor-pointer transition-transform hover:scale-105"
            >
              <Image
                src="/images/caraibanner/bookademo.svg"
                alt="Book a Demo"
                width={300}
                height={90}
                className="h-auto w-[240px]"
                priority
              />
            </button>
          </div>

          {/* Subtitle and Device Images - Side by Side */}
          <div className="flex w-full items-center justify-between gap-[16px]">
            {/* Subtitle - Left Side */}
            <div className="flex flex-shrink-0 items-start">
              <p
                className={ibmPlexSans.className}
                style={{
                  color: '#F9BAFF',
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: '20px',
                  textTransform: 'capitalize',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  maxWidth: '140px',
                }}
              >
                Results in 30 days - Or We&apos;ll Give You Your Money Back
              </p>
            </div>

            {/* Device Images - Right Side */}
            <div className="relative flex h-[160px] flex-1 items-center justify-end overflow-visible">
              {/* Laptop Image */}
              <div className="absolute right-[-15px] top-[20px] z-10 w-[100%]">
                <Image
                  src="/images/caraibanner/laptop.png"
                  alt="CarAI Dashboard on Laptop"
                  width={800}
                  height={500}
                  className="h-auto w-full drop-shadow-2xl"
                  priority
                />
              </div>

              {/* Phone Image */}
              <div className="absolute left-[0px] top-[10%] z-20 w-[30%]">
                <Image
                  src="/images/caraibanner/phone.png"
                  alt="CarAI App on Phone"
                  width={300}
                  height={600}
                  className="h-auto w-full drop-shadow-2xl"
                  priority
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative dotted line */}
      <div className="absolute bottom-0 left-0 right-0 border-b-2 border-dotted border-white opacity-30"></div>
    </section>
  );
};

export default CarAIBannerMobile;
